<template>
  <div class="full-calendar-body">
    <div class="weeks">
      <strong class="week" v-for="week in weekNames">{{week}}</strong>
    </div>
    <div class="dates" ref="dates">
      <div class="dates-bg">
        <div class="week-row" v-for="week in currentDates">
          <!-- @author jeee12 : class="today" 클릭한 날짜 색상 표현되도록 계산형 속성으로 수정 -->
          <div class="day-cell" v-for="day in week" :class="{'today' : changeSelectedDay(day),
                'not-cur-month' : !day.isCurMonth}">
            <!-- <p class="day-number">{{day.monthDay}}</p> -->
            <span class="day-number" @click.stop="calendarNumberClick(day)">{{day.monthDay}}</span>
          </div>
        </div>
      </div>

      <!-- absolute so we can make dynamic td -->
      <div class="dates-events">
        <div class="events-week" v-for="week in currentDates">
          <!-- @author jeee12 : class="today" 클릭한 날짜 색상 표현되도록 계산형 속성으로 수정 -->
          <div class="events-day" v-for="day in week" track-by="$index" :class="{'today' : changeSelectedDay(day),
                'not-cur-month' : !day.isCurMonth}" @click.stop="dayClick(day.date, $event)">
            <!-- <p class="day-number">{{day.monthDay}}</p> -->
            <span class="day-number" @click.stop="calendarNumberClick(day)">{{day.monthDay}}</span>
            <div class="event-box">
              <div class="event-item" v-for="event in day.events" v-if="event.cellIndex <= eventLimit" :class="[classNames(event.cssClass), {
                    'is-start'   : isStart(event.start, day.date),
                    'is-end'     : isEnd(event.end,day.date),
                    'is-opacity' : !event.isShow
                    }]" @click="eventClick(event,$event)">
                <!-- @author jeee12 작업 영향도 표현 slot 추가-->
                <div v-if="isStart(event.start, day.date) && event.slotClass" :style="slotDivStyle()" :class="event.slotClass"></div>
                {{isBegin(event, day.date, day.weekDay)}}
              </div>
              <p v-if="day.events.length > eventLimit" class="more-link" @click.stop="selectThisDay(day, $event)">
                <!-- + {{day.events[day.events.length -1].cellIndex - eventLimit}} more -->
                + {{day.events.length - eventLimit}} more
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- full events when click show more -->
      <div class="more-events" v-show="showMore" :style="{left: morePos.left + 'px', top: morePos.top + 'px'}">
        <div class="more-header">
          <span class="title">{{moreTitle(selectDay.date)}}</span>
          <span class="close" @click.stop="showMore = false">x</span>
        </div>
        <div class="more-body">
          <ul class="body-list">
            <li v-for="event in selectDay.events" v-show="event.isShow" class="body-item" @click="eventClick(event,$event)">
              {{event.title}}
            </li>
          </ul>
        </div>
      </div>

      <slot name="body-card">

      </slot>

    </div>
  </div>
</template>
<script type="text/babel">
import sortBy from 'lodash/sortBy';
import dateFunc from './dateFunc';

/* eslint-disable */
export default {
  props: {
    currentDate: {},
    events: {},
    weekNames: {
      type: Array,
      default: []
    },
    monthNames: {},
    firstDay: {},
  },
  created() {
    this.events.forEach((item, index) => {
      item._id = item.id || index;
      item.end = item.end || item.start;
    })
     // this.events = events
  },
  data() {
    return {
      // weekNames : DAY_NAMES,
      weekMask: [1, 2, 3, 4, 5, 6, 7],
      // events : [],
      isLismit: true,
      eventLimit: 3,
      showMore: false,
      morePos: {
        top: 0,
        left: 0
      },
      selectDay: {},
      selectedCurrentDate: this.currentDate, // @author jeee12 : 클릭한 현재 날짜 색상 표현
    }
  },
  watch: {
    weekNames(val) {
      // console.log('watch weekNames', val)
    },
    currentDate(val) {
      // @author jeee12 : 클릭한 현재 날짜 색상 표현 > TODAY click 오늘 날짜로 돌아올 때 오늘 날짜로 색상 표현
      this.selectedCurrentDate = val;
    }
  },
  computed: {
    currentDates() {
      return this.getCalendar()
    },
  },
  methods: {
    slotDivStyle(event) {
      // @author jeee12 작업의 위험도 색상 dot 표현 적용
      return {

        //edit 1115
        //0402 absolut 추가
        display: 'inline-block',
        width: '4px',
        height:'20px',
        lineHeight: '20px',
        marginLeft: '-8px',
        marginRight:'5px',
        verticalAlign: 'bottom',
        position: 'absolute',
        // borderRight:'1px solid #fff',
        // borderLeft:'2px solid #fff',
        // borderRight:'2px solid #fff',
        // width: '6px',
        // height: '6px',
        // marginRight: '5px',
        // borderRadius: '5px',
      };
    },
    isBegin(event, date, index) {
      let st = new Date(event.start)

      if (index == 0 || st.toDateString() == date.toDateString()) {
        return event.title
      }
      return '　'
    },
    moreTitle(date) {
      let dt = new Date(date)
      return this.weekNames[dt.getDay()] + ', ' + this.monthNames[dt.getMonth()] + '/' + dt.getDate()
    },
    classNames(cssClass) {
      if (!cssClass) return ''
      // string
      if (typeof cssClass == 'string') return cssClass

      // Array
      if (Array.isArray(cssClass)) return cssClass.join(' ')

      // else
      return ''
    },
    getCalendar() {
      // calculate 2d-array of each month
      // first day of this month
      let now = new Date() // today
      let current = new Date(this.currentDate)

      let startDate = dateFunc.getStartDate(current) // 1st day of this month

      let curWeekDay = startDate.getDay()

      // begin date of this table may be some day of last month
      let diff = parseInt(this.firstDay) - curWeekDay
      diff = diff > 0 ? (diff - 7) : diff

      startDate.setDate(startDate.getDate() + diff)
      let calendar = []

      for (let perWeek = 0; perWeek < 6; perWeek++) {

        let week = []

        for (let perDay = 0; perDay < 7; perDay++) {
          week.push({
            monthDay: startDate.getDate(),
            isToday: now.toDateString() == startDate.toDateString(),
            isCurMonth: startDate.getMonth() == current.getMonth(),
            weekDay: perDay,
            date: new Date(startDate),
            events: this.slotEvents(startDate)
          })

          startDate.setDate(startDate.getDate() + 1)
          // if (startDate.toDateString() == endDate.toDateString()) {
          //   isFinal = true
          //   break
          // }
        }
        calendar.push(week)
        // if (isFinal) break
      }
      return calendar
    },
    slotEvents(date) {
      // find all events start from this date
      let cellIndexArr = []
      let thisDayEvents = this.events.filter(day => {
        let dt = new Date(day.start)
        let st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
        let ed = day.end ? new Date(day.end) : st
        // console.log('slotEvt', st, ed, date)
        return date >= st && date <= ed
      })

      // sort by duration
      // thisDayEvents.sort((a, b) => {
      //   if (!a.cellIndex) return 1;
      //   if (!b.cellIndex) return -1;
      //   // return a.cellIndex - b.cellIndex;
      //   if (a.cellIndex > b.cellIndex) return 1;
      //   else if (a.cellIndex < b.cellIndex) return -1;
      //   return 0;
      // })
      thisDayEvents = sortBy(thisDayEvents, [(event) => {
        // @author jeee12 : cellIndex 버그 수정 (Chrome, IE에서 sort 정상작동하도록 수정)
        return event.cellIndex;
      }])

      // mark cellIndex and place holder
      for (let i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || (i + 1);
        thisDayEvents[i].isShow = true;
        if (thisDayEvents[i].cellIndex == i + 1 || i > 2) continue;
        thisDayEvents.splice(i, 0, {
          title: 'holder',
          cellIndex: i + 1,
          start: dateFunc.format(date, 'yyyy-MM-dd'),
          end: dateFunc.format(date, 'yyyy-MM-dd'),
          isShow: false
        });
      }

      return thisDayEvents;
    },
    isStart(eventDate, date) {
      let st = new Date(eventDate)
      return st.toDateString() == date.toDateString()
    },
    isEnd(eventDate, date) {
      let ed = new Date(eventDate)
      return ed.toDateString() == date.toDateString()
    },
    selectThisDay(day, jsEvent) {
      // console.log(day, this.events);
      this.selectDay = day
      this.showMore = true
      this.morePos = this.computePos(event.target)
      this.morePos.top -= 100
      let events = day.events.filter(item => {
        return item.isShow == true
      })
      this.$emit('moreclick', day.date, events, jsEvent)
    },
    computePos(target) {
      let eventRect = target.getBoundingClientRect()
      let pageRect = this.$refs.dates.getBoundingClientRect()
      return {
        left: eventRect.left - pageRect.left,
        top: eventRect.top + eventRect.height - pageRect.top
      }
    },
    dayClick(day, jsEvent) {
      // @author jeee12 : 클릭한 현재 날짜 색상 표현
      this.selectedCurrentDate = day;
      this.$emit('dayclick', day, jsEvent)
    },
    eventClick(event, jsEvent) {
      if (!event.isShow) {
        return
      }
      jsEvent.stopPropagation()
      let pos = this.computePos(jsEvent.target)
      this.$emit('eventclick', event, jsEvent, pos)
    },
    calendarNumberClick(date, jsEvent) {
      // @author jeee12 날짜의 숫자 영역 클릭
      this.$emit('calendarnumberclick', date, jsEvent);
    },
    changeSelectedDay(day) {
      // @author jeee12 클릭한 현재 날짜 cell 색상 표현
      if (day.isToday && this.selectedCurrentDate === null) {
        return true;
      } else {
        const date = this.selectedCurrentDate;
        const selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        // 현재 날짜 (new Date())와 비교시 시/분/초는 제외되도록
        if (selectedDate.getTime() ===  day.date.getTime()) {
          return true;
        }
        return false;
      }
    }
  }
}
/* eslint-enable */
</script>
<style lang="scss">
.full-calendar-body {
    margin-top: 20px;
    .weeks {
        display: flex;
        align-items: stretch;
        border-top: 1px solid #e0e0e0; //$selectedgray
        border-bottom: 1px solid #e0e0e0; //$selectedgray
        border-left: 1px solid #e0e0e0; //$selectedgray
        height: 38px;

        .week {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #e0e0e0; //$selectedgray
        }
    }
    .dates {
      position: relative;

      .week-row {
        // width: 100%;
        // position:absolute;
        border-left: 1px solid #e0e0e0; //$selectedgray
        display: flex;
        .day-cell {
          text-align: right;
          flex: 1;
          min-height: 125px;
          padding: 10px;
          border-right: 1px solid #e0e0e0; //$selectedgray
          border-bottom: 1px solid #e0e0e0; //$selectedgray
          color: #67757c;

          &:nth-child(1):not(.not-cur-month){
            color: #b94a48;
          }
          .day-number {
            text-align: right;
            font-size: 16px; // jeee12
          }
          &.today {
            background-color: #fffef5;
          }
          &.not-cur-month {
            .day-number {
                color: rgba(0,0,0,.24);
            }
          }
        }
        }
        .dates-events {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            .events-week {
                display: flex;
                .events-day {
                    cursor: pointer;
                    flex: 1;
                    // min-height: 109px;
                    min-height: 125px; // jeee12
                    overflow: hidden;
                    text-overflow: ellipsis;
                    .day-number {
                        text-align: right;
                        padding: 4px 5px 4px 4px;
                        opacity: 0;
                        font-size: 20px; // jeee12
                    }
                    &.not-cur-month {
                        .day-number {
                            color: rgba(0,0,0,.24);
                        }
                    }
                    .event-box {
                        .event-item {
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            font-size: 12px;
                            background-color: #f6f6f6;
                            margin-bottom: 5px; //15px;
                            color: rgba(0,0,0,.87);
                            padding: 0 0 0 8px;
                            height: 20px; //23px;
                            line-height: 20px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            &.is-start {
                                // border-top-left-radius:4px;
                                // border-bottom-left-radius:4px;
                            }
                            &.is-end {
                                // border-top-right-radius:4px;
                                // border-bottom-right-radius:4px;
                            }
                            &.is-opacity {
                                opacity: 0;
                            }
                            // @author jeee12
                            // NOTICE: 다음 컴포넌트와 색상은 항상 동기화해야함.
                            // src\components\external\vue-fullcalendar\components\body.vue
                            // src\components\external\vuejs-datepicker\components\Datepicker.vue

                            //0402 수정
                            &.worktype-change {
                              background-color: #e3f3ef;
                            }
                            &.worktype-check {
                              background-color: #f0e7f7
                            }
                            &.worktype-construct {
                              background-color: #e5f2ff;
                            }
                            .workimpact-grade_a {
                              background-color: #e94949
                            }
                            .workimpact-grade_b {
                              background-color: #ffa500;
                            }
                            .workimpact-grade_c {
                              background-color: #68a974;
                            }
                            .workimpact-grade_d {
                              background-color: #2d87d0;
                            }
                            .workimpact-grade_null {
                              background-color: #bebebe;
                            }
                        }
                        .more-link {
                            cursor: pointer;
                            // text-align: right;
                            padding-left: 8px;
                            padding-right: 2px;
                            color: rgba(0,0,0,.38);
                            font-size: 12px; //14px;
                        }
                    }
                }
                .event-box{
                  padding-top: 5px; //17px;
                }
            }
        }
        .more-events {
            position: absolute;
            width: 150px;
            z-index: 2;
            border: 1px solid #eee; //$palegray
            box-shadow: 0 2px 6px rgba(0,0,0,.15);
            .more-header {
                background-color: #eee; //$palegray
                padding: 5px;
                display: flex;
                align-items: center;
                font-size: 14px;
                .title {
                    flex: 1;
                }
                .close {
                    margin-right: 2px;
                    cursor: pointer;
                    font-size: 16px;
                }
            }
            .more-body {
                height: 140px;
                overflow: hidden;
                .body-list {
                    height: 120px;
                    padding: 5px;
                    overflow: auto;
                    background-color: #fff;
                    .body-item {
                        cursor: pointer;
                        font-size: 12px;
                        background-color: #C7E6FD;
                        margin-bottom: 2px;
                        color: rgba(0,0,0,.87);
                        padding: 0 0 0 4px;
                        height: 18px;
                        line-height: 20px;//18px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/external/vue-fullcalendar/components/body.vue